import { useFetch } from "../../../hooks/api";
import { useAppSelector } from "../../../redux/hooks";

export const useTargetReport = (targetIds, targetType, start, end, pre_start, pre_end, group) => {
  const marketPlace = useAppSelector((state) => state.marketPlace);
  const channel = useAppSelector((state) => state.channel);
  return useFetch(
    ["targetReport", targetIds, targetType, start, end, pre_start, pre_end, group],
    `/api/data_report/keyword_report`,
    {
      target_ids: targetIds.join(","),
      start_date: start,
      end_date: end,
      pre_start_date: pre_start,
      pre_end_date: pre_end,
      empty: true,
      channel: channel.currentChannel,
      kw_report: false,
      target_type: targetType,
      group,
      mp: marketPlace.marketPlace,
    },
    {
      default: [],
      enabled: !!start && !!end && !!targetIds.length,
      staleTime: 1000 * 60 * 5,
      select: (res) => res.data,
    },
  );
};
